import React from "react";

export default function ZainSafety() {
  return (
    <div style={{ maxWidth: "800px", margin: "9rem auto", padding: "40px 20px", fontFamily: "Arial, sans-serif", lineHeight: "1.6" }}>
      
      <h1 style={{ fontSize: "28px", marginBottom: "20px" }}>
        Zain Safety
      </h1>

      <p style={{ fontSize: "16px", marginBottom: "16px" }}>
        <strong>Zain Safety</strong> is a client of <strong>Rayan Info Solutions</strong>.
      </p>

      <p style={{ fontSize: "16px", marginBottom: "16px" }}>
        <strong>Rayan Info Solutions</strong> provides WhatsApp Business API services,
        including account setup, integration, and communication solutions for
        <strong> Zain Safety</strong>.
      </p>

      <p style={{ fontSize: "16px" }}>
        This partnership ensures efficient customer communication and seamless
        business operations through WhatsApp.
      </p>

    </div>
  );
}